//#region : Imports

import
{
    Component,
    OnInit,
    SimpleChange,
    ViewChild
}
from '@angular/core';

import
{
    DeviceScans,
    ScanHolder
}
from './stats.model';

import * as Moment from "moment";

import
{
    GlobalsService
}
from '../../globals.service';

import
{
    extendMoment
}
from 'moment-range';

import
{
    AnalyticsComponent
}
from '../analytics/analytics.component';
import
{
    MapViewComponent
}
from '../mapview/mapview.component';
import
{
    AccessGroup,
    AccessLevel
}
from 'src/app/settings';
import
{
    NavigationEnd,
    Router
}
from '@angular/router';

const
{
    Parser
} = require('json2csv');

//#endregion

const moment = extendMoment(Moment);
declare var $: any;
declare var jQuery: any;

@Component(
{
    selector: 'app-stats',
    templateUrl: './stats.component.html',
    styleUrls: ['./stats.component.css']
})
export class StatsComponent implements OnInit
{
    //Locals
    private timeRange: string = "Ready.";
    private editMode: boolean = false;
    private estAlarmsPercentage: number = 0;
    private goodScansPercentage: number = 0;
    private estAlarmsCount: number = 0;
    private goodScansCount: number = 0;
    private deviceName: string = "";
    private editAccess: boolean = false;
    private searchVal: string = "";
    private showSearchField: boolean = false;
    public static instance: StatsComponent = null;
    private activeDevices: number = 0;
    private totalDevices: number = 0;
    private deviceTable: any = null;

    //Default start and en times
    private start = moment().subtract(7, 'days');
    private end = moment();

    //Edit hold-off
    private editDeviceTimers: Map < string, any > = new Map();

    private rawTable: any;
    private jsonData: any;
    private jsonTitle: string;
    private deviceId: string = null;
    private deviceObj: any = {
        enabled: false,
        deployed: false,
        geoaware: false,
        multiclass: false,
        snr: "",
        model: "",
        name: "",
        host: "",
        mobility: "",
        specifics: []
    };
    private qrValue: string = "UNDEFINED";

    private printOptions = {
        debug: false, // show the iframe for debugging
        importCSS: false, // import parent page css
        importStyle: true, // import style tags
        printContainer: true, // print outer container/$.selector
        loadCSS: ["assets/css/print.css", "assets/css/bootstrap.css"], // path to additional css file - use an array [] for multiple
        pageTitle: "", // add title to print page
        removeInline: false, // remove inline styles from print elements
        removeInlineSelector: "*", // custom selectors to filter inline styles. removeInline must be true
        printDelay: 500, // variable print delay
        header: null, // prefix to html
        footer: null, // postfix to html
        base: true, // preserve the BASE tag or accept a string for the URL
        formValues: true, // preserve input/form values
        canvas: true, // copy canvas content
        doctypeString: '', // enter a different doctype for older markup
        removeScripts: true, // remove script tags from print content
        copyTagClasses: false, // copy classes from the html & body tag
        beforePrintEvent: null, // function for printEvent in iframe
        beforePrint: null, // function called before iframe is filled
        afterPrint: () => // function called before iframe is removed
            {
                this.globals.loading = false;
            }
    }

    constructor(private globals: GlobalsService, private router: Router)
    {
        //The iot should be already logged in here
        this.getDeviceData();

        //Keep the reference
        StatsComponent.instance = this;
    }

    ngOnInit(): void
    {
        //Get access level
        let role = this.globals.userAccess.role;
        let allowedRoles = ["root", "super", "agent", "owner"];
        //Determine edit access rights
        this.editAccess = allowedRoles.includes(role);

        $('#report-range').daterangepicker(
        {
            startDate: this.start,
            endDate: this.end,
            ranges:
            {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, this.cb);

        this.cb(this.start, this.end, undefined, false);

        //Defer
        setTimeout(() =>
        {
            this.createDeviceTable();
        }, 1000);
    }

    public static redraw(snr ? : string, name ? : string)
    {
        let me: StatsComponent = StatsComponent.instance;

        if (me)
        {
            me.deviceTable.ajax.reload(null, false);
        }
    }

    ngAfterViewInit()
    {
        this.calcSize();

        //Catch enter event on search bar
        let me = this;
        $("#searchfield").on('keyup', function(e)
        {
            if (e.keyCode === 13)
            {
                me.searchDevices();
            }
        });

        //Subscribe to global events
        this.globals.globalEvents.on('resize', () =>
        {
            this.calcSize();
        });

        //Raw data date range
        //Initial start and end times
        this.start = moment().subtract(30, 'days');
        this.end = moment();

        //Attach date-range picker
        $('#date-time').daterangepicker(
        {
            startDate: this.start,
            endDate: this.end,
            timePicker: true,
            scope: this
        }, this.updateRangeInfo);

        //Set a scope variable
        let dtp = $('#date-time').data('daterangepicker');
        dtp.scope = this;

        //Update the 
        this.updateRangeInfo(this.start, this.end);
    }

    updateRangeInfo(start: any, end: any)
    {
        let me = this;
        //Date range display
        $('#date-time span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));

        //Get the instance
        let dtp = $('#date-time').data('daterangepicker');
        let scp = dtp.scope;

        //Update
        if (scp)
        {
            dtp.startDate = start;
            dtp.endDate = end;
            scp.start = start;
            scp.end = end;

            dtp.scope = scp;
            scp.createRawTable();
        }
    }

    hasDeviceAccess()
    {
        return (this.globals.permitSingle(AccessGroup.iot, AccessLevel.EDIT));
    }

    calcSize()
    {
        //Set the card height to the remaining space
        let margins = 18;
        let h = $('.stats-totals').height();
        let nav = $('app-nav').height();
        $('.device-scans').height(nav - h - margins);
    }

    getScanDataEntry(dataMap: Map < string, Map < string, ScanHolder >> , snr: string, dt: any): ScanHolder
    {
        //Get the scan day
        let dayName = moment(dt).format("MM/DD");
        let dataEntry: ScanHolder = dataMap.get(dayName).get(snr);

        //If not exist then great
        if (!dataEntry)
        {
            dataEntry = new ScanHolder();
            dataMap.get(dayName).set(snr, dataEntry);
        }

        return dataEntry;
    }

    createDeviceTable()
    {
        //Locals
        let me = this;

        //Regenerate the device tables
        me.deviceTable = $('#stats-device-table').DataTable(
        {
            paging: true,
            ordering: true,
            info: true,
            serverSide: true,
            processing: true,
            responsive: true,
            destroy: true,
            searching: false,
            lengthChange: false,
            pagingType: "simple",
            pageResize: false,
            order: [
                [0, 'asc']
            ],
            language:
            {
                paginate:
                {
                    previous: "&laquo;",
                    next: "&raquo;"
                },
                search: "_INPUT_",
                searchPlaceholder: "Search devices",
                emptyTable: `No devices found`,
                info: "Page _PAGE_ of _PAGES_"
            },
            columns: [
            {
                data: "name",
                orderable: true,
                searchable: true,
                className: "column-bold"
            },
            {
                data: "actions",
                orderable: false,
                searchable: false,
                className: "column-nowrap column-right"
            }],
            ajax:
            {
                url: me.globals.apiRootNew + '/iot/proxy',
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                beforeSend: function(request)
                {
                    //Setup the header
                    request.setRequestHeader("api-key", me.globals.apiKey);
                },

                data: function(data)
                {
                    //Format the server object
                    var o = {
                        token: me.globals.token,
                        endpoint: "/device/page",
                        body:
                        {
                            token: me.globals.iotToken,
                            seq: data.draw,
                            from: data.start,
                            length: data.length,
                            search: me.searchVal.toLocaleLowerCase(),
                            order: data.columns[data.order[0].column].data,
                            direction: data.order[0].dir
                        }
                    }

                    //To string
                    return JSON.stringify(o);
                },

                dataFilter: function(data)
                {
                    //Make an object
                    var json = jQuery.parseJSON(data);

                    //Session expired
                    if (!json.data)
                    {
                        return JSON.stringify(
                        {
                            recordsTotal: 0,
                            recordsFiltered: 0,
                            draw: 0,
                            data: []
                        });
                    }

                    let devices = json.data.devices;

                    //Add the tools field
                    for (var i = 0; i < devices.length; i++)
                    {
                        //Action icons
                        var tools = me.globals.getToolButtonHtml('stats-show-raw-data', 'fa-database', 5, 'Show raw data');
                        tools += me.globals.getToolButtonHtml('stats-show-device-detail', 'fa-info-circle', 5, 'Show device info');
                        tools += me.globals.getToolButtonHtml('stats-show-device-locate', 'fa-map-marker-alt', 0, 'Locate device', me.globals.currentPage != 'map');



                        devices[i].actions = tools;
                    }

                    //Return an empty record
                    return JSON.stringify(
                    {
                        recordsTotal: json.data.total,
                        recordsFiltered: json.data.filtered,
                        draw: json.data.seq,
                        data: devices
                    });
                }
            }
        });

        //Raw data click
        me.deviceTable.on('click', '.stats-show-raw-data', function()
        {
            //Get the data
            let tr = $(this).closest('tr');
            let data = me.deviceTable.row(tr[0]).data();

            if (data && data.id)
            {
                me.showRawData(data.id);
            }
        });

        //Device detail click
        me.deviceTable.on('click', '.stats-show-device-detail', function()
        {
            //Get the data
            let tr = $(this).closest('tr');
            let data = me.deviceTable.row(tr[0]).data();

            if (data)
            {
                me.showDeviceDetails(data)
            }
        });

        //Device location click
        me.deviceTable.on('click', '.stats-show-device-locate', function()
        {
            //Get the data
            let tr = $(this).closest('tr');
            let data = me.deviceTable.row(tr[0]).data();

            if (data && data.state && data.state.position)
            {
                me.locate(data.snr, data)
            }
        });

         

        me.router.events.subscribe((val) =>
        {
            if (val instanceof NavigationEnd)
            {
                if (me.globals.currentPage != 'map')
                {
                    $('.stats-show-device-locate').addClass('saf-disabled');
                }
                else
                {
                    $('.stats-show-device-locate').removeClass('saf-disabled');
                }
            }
        });
    }

    getDeviceData(showProgress: boolean = true)
    {
        //Totals
        let totalScans: number = 0;
        let totalAlarms: number = 0;
        this.globals.loading = showProgress;

        //#region : Prepare data arrays

        let deviceMap: Map < string, ScanHolder > = new Map();
        let range = moment.range(this.start, this.end);
        let days = Array.from(range.by('days')).map(m => m.format('MM/DD'));

        //Map<dayId, Map<snr, ScanDay>>
        let dataMap: Map < string, Map < string, ScanHolder >> = new Map();

        //Prepare the data map
        for (var i = 0; i < days.length; i++)
        {
            dataMap.set(days[i], new Map());
        }

        //#endregion

        //Get models
        let models: any = this.globals.getModels();

        
        this.globals.deviceList(undefined, models, undefined, undefined, (devices: any) =>
        {
            //#region : Build the device map   

            if (devices && Array.isArray(devices))
            {
                for (var i = 0; i < devices.length; i++)
                {
                    //Get the device info
                    let dev = devices[i];
                    let name = dev.name;
                    let snr = dev.snr;

                    deviceMap.set(snr, new ScanHolder(name, dev));

                    if (dev.enabled && dev.deployed)
                    {
                        this.activeDevices++;
                    }
                }
                this.globals.activeDevices = this.activeDevices;
            }

            ///////////////////
            AnalyticsComponent.redraw();
            this.globals.deviceScans = devices;
            this.globals.loading = false;
            ///////////////////

            //#endregion
        });
    }

    updateTotals(good: number, alarms: number)
    {
        //Calculate the total
        let total: number = good + alarms;

        if (total > 0)
        {
            //Set the counts
            this.goodScansCount = good;
            this.estAlarmsCount = alarms;

            //Calculate the percentage
            this.goodScansPercentage = Math.round(100 * good / total);
            this.estAlarmsPercentage = Math.round(100 * alarms / total);
        }
        else
        {
            this.goodScansCount = 0;
            this.estAlarmsCount = 0;
            this.goodScansPercentage = 0;
            this.estAlarmsPercentage = 0;
        }
    }

    cb(start: any, end: any, label ? : any, updateDevices: boolean = true)
    {
        //Get the reference to the stats object
        let me = StatsComponent.instance;

        //Update
        me.start = start;
        me.end = end;

        //Visuals
        me.timeRange = start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');
        me.globals.currentPeriod = me.timeRange;

        if (updateDevices)
        {
            me.getDeviceData()
        }
    }

    download(snr: string)
    {
        this.globals.loading = true;
        let data: any = this.globals.getTotals(snr);

        if (data.length > 0)
        {
            //#region : Format the data

            let dataFormatted: any[] = [];

            for (var i = 1; i < data.length; i++)
            {
                dataFormatted.push(
                {
                    Day: data[i][0],
                    Scans: data[i][1],
                    Alarms: data[i][3],
                });
            }

            //#endregion

            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(dataFormatted);

            this.exportCSVFile(csv, `${this.globals.buildSettings.downloadPrefix}_${snr}`);
        }
        else
        {
            this.globals.showWarningAlert("Export Data", "There is no data available.");
        }

        setTimeout(() =>
        {
            this.globals.loading = false;
        }, 3000);
    }

    plot(snr: string, name: string)
    {
        AnalyticsComponent.redraw(snr, name);
    }

    exportCSVFile(csv: string, filename: string)
    {
        var exportedFilename = filename + '.csv' || 'export.csv';

        var blob = new Blob([csv],
        {
            type: 'text/csv;charset=utf-8;'
        });

        // if (navigator.msSaveBlob)
        // {
        //     // IE 10+
        //     navigator.msSaveBlob(blob, exportedFilename);
        // }
        // else
        // {
            var link = document.createElement("a");

            if (link.download !== undefined)
            {
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        // }
    }

    locate(snr: string, item: any)
    {
        if (item && item && item.state && item.state.position)
        {
            let pos = item.state.position;

            MapViewComponent.goto(pos.latitude, pos.longitude, snr)
        }
    }

    remove(snr: string, item: any)
    {
        //Get the device ID
        let devicesId = item.id;

        //Confirm and delete
        this.globals.showConfirmAlert("Delete device", "The device will be permanently deleted. Continue?", "DELETE", "CANCEL", () =>
        {
            this.globals.deviceRemove(devicesId, (res) =>
            {
                //Refresh
                this.getDeviceData();
            });
        })
    }

    searchDevices()
    {
        //Filter the deviceScans Object using a keyword
        let me = this;

        this.deviceTable.search(me.searchVal.toLocaleLowerCase()).draw();
    }

    toggleSearchVis()
    {
        this.showSearchField = !this.showSearchField;
    }

    editName(snr: string, item: any, event: any)
    {
        //Get the new value
        let devicesId = item.id;
        let newValue = event.target.value;

        //Restart the timer
        let timer = this.editDeviceTimers.get(snr);
        if (timer) clearTimeout(timer);

        //Hold-off
        timer = setTimeout(() =>
        {
            //Remove the timer entry
            this.editDeviceTimers.delete(snr);

            //Data to change
            let device = {
                name: newValue
            };

            //Update device
            this.globals.deviceSet(devicesId, device, (res: any) =>
            {
                //Update the item with the new value
                item.name = newValue;

                this.getDeviceData(false);
            }, () =>
            {
                this.globals.showWarningAlert("Device Name", "Cannot update device name.");
            });

        }, 3000);

        //Remember the timeout
        this.editDeviceTimers.set(snr, timer);
    }

    print(snr: string, item: any)
    {
        //Start loading - will be cleared in the print options
        this.globals.loading = true;
        this.globals.printTitle = `${item.name} - ${snr}`;

        //Ensure that we are on the analytics page
        this.router.navigate(['analytics']);

        //Draw the device
        AnalyticsComponent.redraw(snr, item.name);

        //#region : Process data

        let table = `<table class='table'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Day</th>
                    <th>Scans</th>
                    <th>Alarms</th>
                </tr>
            </thead>
            <tbody>`;

        let data: any = this.globals.getTotals(snr);

        if (data.length > 0)
        {
            for (var i = 1; i < data.length; i++)
            {
                let day = data[i][0];
                let scans = data[i][1];
                let alarms = data[i][3];

                table += `<tr>
                    <td>${i}</td><td>${day}</td><td>${scans}</td><td>${alarms}</td>
                </tr>`;
            }
        }

        table += "</tbody></table>";

        //#endregion

        //Defer
        setTimeout(() =>
        {
            //Clear the content
            $("#print-content").empty();

            //Add new content
            $("#print-content").append("<div class='mt-5 mb-3'></div>");
            $(".print-stats-totals").clone().appendTo("#print-content");
            $("#print-content").append("<div class='mt-5 mb-3'><h4>Analytics</h4></div><hr class='pb-4'>");
            $(".print-chart-devices").clone().appendTo("#print-content");
            $("#print-content").append(`<div class='mt-5 mb-3'><h4>Data</h4></div>`);
            $("#print-content").append(`${table}`);

            //Do print
            $("#print-area").printThis(this.printOptions);
        }, 1000);
    }

    printAll()
    {
        this.globals.printTitle = `Summary`;

        //Start loading - will be cleared in the print options
        this.globals.loading = true;

        //Ensure that we are on the analytics page
        this.router.navigate(['analytics']);

        //Defer
        setTimeout(() =>
        {
            //Clear the content
            $("#print-content").empty();

            //Add new content
            $("#print-content").append("<div class='mt-5 mb-3'></div>");
            $(".print-stats-totals").clone().appendTo("#print-content");
            $("#print-content").append("<div class='mt-5 mb-3'><h4>Analytics</h4></div><hr class='pb-4'>");
            $(".print-chart-totals").clone().appendTo("#print-content");
            $("#print-content").append("<div class='mt-5 mb-3'><h4>Device Summary</h4></div><hr class='pb-4'>");
            $(".print-device-detail").clone().appendTo("#print-content");

            //Do print
            $("#print-area").printThis(this.printOptions);
        }, 1000);
    }

    onResized(event)
    {
        this.calcSize();
    }

    pad(text: string, size: number)
    {
        var s = text;

        while (s.length < (size || 2))
        {
            s = "0" + s;
        }
        return s;
    }

    showRawData(deviceId: string)
    {
        //Keep
        this.deviceId = deviceId;

        //Update start end times
        this.start = moment().subtract(30, 'days');
        this.end = moment();

        this.updateRangeInfo(this.start, this.end);
        // this.cb(this.start, this.end, undefined, true);

        //update calendar

        // this.createTable();

        //Show the modal
        this.rawTable.ajax.reload(null, false);
        $('#modal-raw-data').modal('show');
    }

    showDetail(data: any, title: string)
    {
        //Keep
        this.jsonData = data;
        this.jsonTitle = title;

        $('#modal-show-data').modal('show');

        //Apply css
        $('.ngx-json-viewer').css('overflow', 'auto');
    }

    createRawTable()
    {
        if (this.start && this.end && this.deviceId)
        {
            //Helper vars
            let me = this;
            let isoStart = this.start.toISOString();
            let isoEnd = this.end.toISOString();
            //Regenerate the device tables
            me.rawTable = $('#raw-table').DataTable(
            {
                paging: true,
                ordering: true,
                info: true,
                serverSide: true,
                processing: true,
                responsive: true,
                    destroy: true,
                filter:false,
                order: [0, 'desc'],
                initComplete: (settings: any, json: any) =>
                {

                },
                language:
                {
                    paginate:
                    {
                        previous: "&laquo;",
                        next: "&raquo;"
                    },
                    // search: "_INPUT_",
                    // searchPlaceholder: "Search raw data",
                    emptyTable: `No raw data available`
                },
                columns: [
                {
                    data: "created",
                    orderable: true,
                    searchable: false,
                    className: ""
                },
                {
                    data: "elapsed",
                    orderable: false,
                    searchable: false,
                    className: "column-center"
                },
                {
                    data: "version",
                    orderable: true,
                    searchable: true,
                    className: "column-center"
                },
                {
                    data: "events",
                    orderable: false,
                    searchable: false
                },
                {
                    data: "status",
                    orderable: false,
                    searchable: false,
                    className: "column-nowrap column-center"
                }],
                ajax:
                {
                    url: me.globals.apiRootNew + '/iot/proxy',
                    type: 'POST',
                    contentType: "application/json",
                    dataType: 'json',
                    beforeSend: function(request)
                    {
                        //Setup the header
                        request.setRequestHeader("api-key", me.globals.apiKey);
                    },

                    data: function(data)
                    {
                        //Format the server object
                        var o = {
                            token: me.globals.token,
                            endpoint: "/raw/page",
                            body:
                            {
                                token: me.globals.iotToken,
                                seq: data.draw,
                                from: data.start,
                                length: data.length,
                                search: data.search.value,
                                order: data.columns[data.order[0].column].data,
                                direction: data.order[0].dir,
                                deviceId: me.deviceId,
                                start: isoStart,
                                end: isoEnd
                            }
                        }

                        //To string
                        return JSON.stringify(o);
                    },

                    dataFilter: function(data)
                    {
                        //Make an object
                        var json = jQuery.parseJSON(data);

                        //Session expired
                        if (!json.data)
                        {
                            return JSON.stringify(
                            {
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                draw: 0,
                                data: []
                            });
                        }

                        let raw = json.data.raw;
                        let prevDate: any = null;

                        //Add the tools field
                        for (var i = 0; i < raw.length; i++)
                        {
                            //Format the date and time                            
                            let isoDate: any = new Date(raw[i].created);
                            let isoMoment: any = moment(isoDate);
                            raw[i].created = isoMoment.format(me.globals.dateTimeFormat);

                            //Elapsed     
                            if (prevDate)
                            {
                                //Calculate the differences
                                var diffSec = Math.round(Math.abs((isoDate - prevDate) / 1000));
                                let diffMin = Math.floor(diffSec / 60);
                                diffSec = diffSec - diffMin * 60;

                                raw[i].elapsed = `${me.pad(diffMin.toString(), 2)}:${me.pad(diffSec.toString(), 2)}`;
                            }
                            else
                            {
                                raw[i].elapsed = 0;
                            }

                            //#region : State info

                            let state = raw[i].state;
                            let events = (state && state.events && state.events.length > 0);
                            let sensors = (state && state.sensors && state.sensors.length > 0);
                            let status = (state && state.status && state.status.length > 0);
                            let position = (state && state.position);

                            raw[i].status = events ? me.globals.getToolButtonHtml('event-data', 'fa-bolt', 5, 'Show events') : '';
                            raw[i].status += sensors ? me.globals.getToolButtonHtml('sensor-data', 'fa-temperature-low', 5, 'Show sensor data') : '';
                            raw[i].status += status ? me.globals.getToolButtonHtml('status-data', 'fa-info-circle', 5, 'Show status information') : '';
                            raw[i].status += position ? me.globals.getToolButtonHtml('position-data', 'fa-map-marker-alt', 5, 'Show position information') : '';
                            raw[i].status += raw[i].via ? me.globals.getToolButtonHtml('via-data', 'fa-satellite-dish', 5, `Via ${raw[i].via}`) : '';
                            raw[i].status += state ? me.globals.getToolButtonHtml('all-data', 'fa-ball-pile', 0, 'All data') : '';

                            //Events
                            raw[i].events = '';
                            var a = '';

                            if (events)
                            {
                                for (var j = 0; j < state.events.length; j++)
                                {
                                    let e = state.events[j];

                                    raw[i].events += (a + e.cause);
                                    a = ', ';
                                }
                            }

                            //#endregion

                            prevDate = isoDate;
                        }

                        //Return an empty record
                        return JSON.stringify(
                        {
                            recordsTotal: json.data.total,
                            recordsFiltered: json.data.filtered,
                            draw: json.data.seq,
                            data: raw
                        });
                    }
                }
            });

            //Event data click
            me.rawTable.on('click', '.event-data', function()
            {
                //Get the data
                let tr = $(this).closest('tr');
                let data = me.rawTable.row(tr[0]).data();

                if (data.state && data.state.events)
                {
                    me.showDetail(data.state.events, 'Event Data');
                }
            });

            //Sensor data click
            me.rawTable.on('click', '.sensor-data', function()
            {
                //Get the data
                let tr = $(this).closest('tr');
                let data = me.rawTable.row(tr[0]).data();

                if (data.state && data.state.sensors)
                {
                    me.showDetail(data.state.sensors, 'Sensor Data');
                }
            });

            //Status data click
            me.rawTable.on('click', '.status-data', function()
            {
                //Get the data
                let tr = $(this).closest('tr');
                let data = me.rawTable.row(tr[0]).data();

                if (data.state && data.state.status)
                {
                    me.showDetail(data.state.status, 'Status Data');
                }
            });

            //All data click
            me.rawTable.on('click', '.all-data', function()
            {
                //Get the data
                let tr = $(this).closest('tr');
                let data = me.rawTable.row(tr[0]).data();

                if (data.state)
                {
                    me.showDetail(data.state, 'All Data');
                }
            });
        }
    }

    showDeviceDetails(item)
    {

        this.deviceObj = item;
        console.log(item)
        $('#modal-device-info').modal('show');
    }

    showQrCode()
    {
        //Setup data
        let dev = this.deviceObj;
        let data: any = {
            snr: dev.snr,
            model: dev.model,
            host: dev.host,
            name: dev.name,
            timezone: dev.timezone
        };

        this.qrValue = JSON.stringify(data);

        $('#modal-qr-code').modal('show');
    }

    showDeviceSpecifics()
    {
        console.log(this.deviceObj)
        $('#modal-show-specifics').modal('show');
    }
}